import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TaskListDocumentImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TaskListDocumentImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const TaskListDocumentImage = (t0)=>{
    const $ = c(45);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M57.6282 14.3795C59.146 15.8811 60 17.927 60 20.0614V59.9643C60 64.6718 56.1428 63.9619 51.3846 63.9619H12.6154C7.85724 63.9619 4 64.6718 4 59.9643V8.52378C4 3.81622 7.85724 4.91066e-07 12.6154 0H39.8041C41.9119 0 43.9344 0.831313 45.4324 2.31329L57.6282 14.3795Z",
            fill: "white"
        });
        $[2] = t1;
    } else t1 = $[2];
    const t2 = `url(#paint0_${props.id})`;
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M4 59.9643V8.52378C4 3.81622 7.85724 4.91066e-07 12.6154 0H39.8041C41.9119 0 43.9344 0.831313 45.4324 2.31329L57.6282 14.3795C59.146 15.8811 60 17.927 60 20.0614V59.9643C60 64.3775 56.6099 64.0295 52.2656 63.9687L51.3846 63.9619L51.3848 62.9625C51.9902 62.9625 52.5802 62.9738 53.1387 62.9839C53.7012 62.9942 54.2305 63.003 54.7314 62.9996C55.7455 62.9927 56.5693 62.9344 57.2217 62.7624C57.8557 62.5953 58.2553 62.3401 58.5156 61.9845C58.7839 61.6181 59 61.0138 59 59.9643V20.0613C59 18.1937 58.2528 16.4035 56.9248 15.0896L44.7285 3.02359C43.4179 1.72694 41.6479 0.999404 39.8037 0.999404H12.6152C8.3999 0.999485 5 4.37816 5 8.52422V59.9643C5 61.0138 5.21607 61.6181 5.48438 61.9845C5.74474 62.3401 6.14429 62.5953 6.77832 62.7624C7.43068 62.9344 8.25455 62.9927 9.26855 62.9996C9.76946 63.003 10.2988 62.9942 10.8613 62.9839C11.4198 62.9738 12.0098 62.9625 12.6152 62.9625L12.6154 63.9619C7.85724 63.9619 4 64.6718 4 59.9643ZM51.3848 62.9625L51.3846 63.9619H12.6154L12.6152 62.9625H51.3848Z",
            fill: t2
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = `url(#paint1_${props.id})`;
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M37 4.82555C37 3.0448 39.1543 2.153 40.4142 3.41218L56.5858 19.5741C57.8457 20.8333 56.9534 22.9863 55.1716 22.9863H41C38.7909 22.9863 37 21.1965 37 18.9887V4.82555Z",
            fill: t4
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = `url(#paint2_${props.id})`;
    let t7;
    if ($[7] !== t6) {
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M11 20.4878C11 19.1079 12.1193 17.9893 13.5 17.9893H27.5C28.8807 17.9893 30 19.1079 30 20.4878C30 21.8677 28.8807 22.9863 27.5 22.9863H13.5C12.1193 22.9863 11 21.8677 11 20.4878Z",
            fill: t6
        });
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    const t8 = `url(#paint3_${props.id})`;
    let t9;
    if ($[9] !== t8) {
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M11 29.4824C11 28.1025 12.1193 26.9839 13.5 26.9839H45.5C46.8807 26.9839 48 28.1025 48 29.4824C48 30.8623 46.8807 31.9809 45.5 31.9809H13.5C12.1193 31.9809 11 30.8623 11 29.4824Z",
            fill: t8
        });
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t3 || $[12] !== t5 || $[13] !== t7 || $[14] !== t9) {
        t10 = /*#__PURE__*/ jsx("g", {
            children: /*#__PURE__*/ jsxs("g", {
                children: [
                    t1,
                    t3,
                    t5,
                    t7,
                    t9
                ]
            })
        });
        $[11] = t3;
        $[12] = t5;
        $[13] = t7;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const t11 = `paint0_${props.id}`;
    let t12;
    let t13;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ jsx("stop", {
            stopColor: "currentColor"
        });
        t13 = /*#__PURE__*/ jsx("stop", {
            offset: "0.780666",
            stopColor: "white"
        });
        $[16] = t12;
        $[17] = t13;
    } else {
        t12 = $[16];
        t13 = $[17];
    }
    let t14;
    if ($[18] !== t11) {
        t14 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t11,
            x1: "40",
            y1: "-14.4914",
            x2: "18.524",
            y2: "67.4661",
            gradientUnits: "userSpaceOnUse",
            children: [
                t12,
                t13
            ]
        });
        $[18] = t11;
        $[19] = t14;
    } else t14 = $[19];
    const t15 = `paint1_${props.id}`;
    let t16;
    let t17;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t17 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[20] = t16;
        $[21] = t17;
    } else {
        t16 = $[20];
        t17 = $[21];
    }
    let t18;
    if ($[22] !== t15) {
        t18 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t15,
            x1: "48.5",
            y1: "-2.29247e-08",
            x2: "48.5",
            y2: "22.9863",
            gradientUnits: "userSpaceOnUse",
            children: [
                t16,
                t17
            ]
        });
        $[22] = t15;
        $[23] = t18;
    } else t18 = $[23];
    const t19 = `paint2_${props.id}`;
    let t20;
    let t21;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t21 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[24] = t20;
        $[25] = t21;
    } else {
        t20 = $[24];
        t21 = $[25];
    }
    let t22;
    if ($[26] !== t19) {
        t22 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t19,
            x1: "20.5",
            y1: "17.9893",
            x2: "20.5",
            y2: "22.9863",
            gradientUnits: "userSpaceOnUse",
            children: [
                t20,
                t21
            ]
        });
        $[26] = t19;
        $[27] = t22;
    } else t22 = $[27];
    const t23 = `paint3_${props.id}`;
    let t24;
    let t25;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t25 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[28] = t24;
        $[29] = t25;
    } else {
        t24 = $[28];
        t25 = $[29];
    }
    let t26;
    if ($[30] !== t23) {
        t26 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t23,
            x1: "29.5",
            y1: "26.9839",
            x2: "29.5",
            y2: "31.9809",
            gradientUnits: "userSpaceOnUse",
            children: [
                t24,
                t25
            ]
        });
        $[30] = t23;
        $[31] = t26;
    } else t26 = $[31];
    const t27 = `clip0_${props.id}`;
    let t28;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ jsx("rect", {
            width: "64",
            height: "60",
            fill: "white"
        });
        $[32] = t28;
    } else t28 = $[32];
    let t29;
    if ($[33] !== t27) {
        t29 = /*#__PURE__*/ jsx("clipPath", {
            id: t27,
            children: t28
        });
        $[33] = t27;
        $[34] = t29;
    } else t29 = $[34];
    let t30;
    if ($[35] !== t14 || $[36] !== t18 || $[37] !== t22 || $[38] !== t26 || $[39] !== t29) {
        t30 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t14,
                t18,
                t22,
                t26,
                t29
            ]
        });
        $[35] = t14;
        $[36] = t18;
        $[37] = t22;
        $[38] = t26;
        $[39] = t29;
        $[40] = t30;
    } else t30 = $[40];
    let t31;
    if ($[41] !== props || $[42] !== t10 || $[43] !== t30) {
        t31 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "64",
            height: "60",
            viewBox: "0 0 64 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t10,
                t30
            ]
        }));
        $[41] = props;
        $[42] = t10;
        $[43] = t30;
        $[44] = t31;
    } else t31 = $[44];
    return t31;
};
export { TaskListDocumentImage };
